var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { cloneElement } from 'react';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
export const Stats = (_a) => {
    var { children, icon, title } = _a, rest = __rest(_a, ["children", "icon", "title"]);
    const classes = useStyles(rest);
    return (React.createElement(Tooltip, { title: title },
        React.createElement(Grid, { container: true, alignItems: "center", className: classes.root },
            cloneElement(icon, {
                className: classNames(classes.icon, icon.className),
            }),
            children)));
};
export const StatsText = (_a) => {
    var { children } = _a, rest = __rest(_a, ["children"]);
    const classes = useStyles(rest);
    return (React.createElement(Typography, { variant: "caption", color: "textSecondary", className: classes.text }, children));
};
const useStyles = makeStyles(theme => ({
    root: {
        marginRight: theme.spacing(2),
        width: 'auto',
    },
    icon: {
        marginRight: theme.spacing(),
    },
    text: {},
}), {
    name: 'Layer7Stats',
});
//# sourceMappingURL=Stats.js.map